import { getCall, postCall } from "../utils/calls";
import { formatDate } from "../utils/utils";
import { dispatchErrorMessage } from "../utils/toast";

export const getChatAnalytics = async (dates) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
  };
  const res = await postCall("/analytics/chats/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getMessageAnalytics = async (dates) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
  };
  const res = await postCall("/analytics/messages/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getConversationAnalytics = async (dates) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
  };
  const res = await postCall("/analytics/conversations/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getIntentAnalytics = async (dates) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
  };
  const res = await postCall("/analytics/intents/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getIntentStaticAnalytics = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/analytics/static/intents/" + bot_id);
  if (res[0]) {
    return res[0].intents_analytics;
  } else {
    return null;
  }
};

export const getBillings = async (month) => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/analytics/pricing/" + bot_id + "/" + month);
  if (res[0]) {
    return res[0].pricing_analytics;
  } else {
    return null;
  }
};

export const getFormsAnalytics = async (dates, formId) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
  };
  const res = await postCall("/analytics/forms/" + bot_id + "/" + formId, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getFormsForAnalytics = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/analytics/forms/" + bot_id);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getLastEvaluation = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/analytics/last/evaluation/chats/" + bot_id);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const generateConversationsEvaluation = async ({
  conversationsLimit,
  onProgress,
}) => {
  const bot_id = localStorage.getItem("bot");

  const res = await getCall(
    `/analytics/evaluation/chats/${bot_id}?limit=${Number(conversationsLimit)}`
  );

  if (!res || !res[0]?.task_id) {
    dispatchErrorMessage(null, res, "Error al cargar los datos.");
    return null;
  }

  const taskId = res[0].task_id;
  const maxRetries = 100;
  const delay = 5000; // 5 segundos
  let attempt = 0;

  while (attempt < maxRetries) {
    attempt++;

    const statusRes = await getCall(`/tasks/status/${bot_id}/${taskId}`);

    if (!statusRes || !statusRes[0]?.data) {
      await new Promise(r => setTimeout(r, delay));
      continue;
    }

    const taskData = statusRes[0].data;
    const progress = taskData?.progress || taskData?.response?.progress;
    if (
      progress &&
      typeof progress.current === "number" &&
      typeof progress.total === "number"
    ) {
      onProgress?.(progress);
    }

    const status = taskData.status;
    if (status === "completed") {
      return taskData.response;
    }

    if (status === "failed") {
      const backendError = taskData?.response?.error || "Error al procesar.";
      dispatchErrorMessage(null, null, backendError);
      return null;
    }

    await new Promise(r => setTimeout(r, delay));
  }
  dispatchErrorMessage(null, null, "Error al procesar la evaluación de conversaciones.");
  return null;
};

// Templates Messages Analytics
export const getTemplatesAnalytics = async (dates) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
  };
  const res = await postCall("/analytics/templates/" + bot_id,
    data
  );
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const getTemplateDetailsAnalytics = async (dates, templateName) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    date_end: formatDate(dates.endDate),
    date_start: formatDate(dates.initDate),
    template_name: templateName,
  };
  const res = await postCall("/analytics/templates/details/" + bot_id,
    data
  );
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};